import {Transaction, TransactionDetail} from '../model/shared/transaction/transaction';
import {InbTransactionDetail} from '../model/shared/transaction/transaction';
import {BaseResponse} from './internal/baseresponse';
export class TransactionDetailResult extends BaseResponse {
  data: TransactionDetail;
}

export class InbTransactionDetailResult extends BaseResponse {
  data: InbTransactionDetail;
}



// WEBPACK FOOTER //
// ./src/app/response/transactiondetailresult.ts